import React from 'react';
import {
  getHeroContent, HeroImage, StoreLogo, CartBtn, TabContent, StoreFooter, FaHeart, getTabLabel, InlineEditableText,MdSearch
} from './ThemeLayoutHelpers';


export default function SlateLayout({ p }) {
  const T = p.storeTheme || {};
  const primary = T.primaryColor || "#60a5fa";
  const text = p.storefrontText || {};
  const copy = getHeroContent(p, {
    eyebrow: T.themeName ? `${T.themeName} • Dark Mode` : "Slate • Dark Mode",
    title: "Sleek. Dark. Modern.",
    subtitle: "A premium dark-first experience for brands that mean business.",
    primaryCta: "Browse Products",
    secondaryCta: "Our Story",
  });
  return (
    <div className="min-h-screen flex flex-col bg-gray-900 text-gray-100" style={{ fontFamily: T.fontFamily || "Montserrat, sans-serif" }}>
      <nav className="sticky top-0 z-40 border-b border-gray-800 bg-gray-900/90 backdrop-blur-xl">
        <div className="max-w-7xl mx-auto px-5 py-3.5 flex items-center gap-4">
          <StoreLogo storeInfo={p.storeInfo} border="border-2 border-gray-700" />
          <span className="font-bold tracking-wider text-sm text-gray-100">
            <InlineEditableText p={p} field="businessName" value={p.storeInfo?.businessName}>
              {p.storeInfo?.businessName || "Your Store"}
            </InlineEditableText>
          </span>
          <div className="hidden md:block flex-1 ml-4 relative max-w-sm">
            <MdSearch className="absolute left-3 top-2.5 text-gray-500 text-lg" />
            <input value={p.searchQuery} onChange={e => p.setSearchQuery(e.target.value)} placeholder={text.searchProducts || "Search products"} className="w-full py-2 pl-10 pr-4 rounded-xl bg-gray-800 border border-gray-700 text-gray-200 text-sm placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-blue-500" />
          </div>
          <div className="ml-auto flex items-center gap-2.5">
            <button onClick={p.handleGoToWishlist} className="relative p-2.5 rounded-xl border border-gray-700 hover:bg-gray-800" style={{ color: primary }}>
              <FaHeart className="text-base" />
              {p.wishlistCount > 0 && <span className="absolute -top-1 -right-1 h-4 w-4 text-[9px] rounded-full text-white flex items-center justify-center" style={{ backgroundColor: primary }}>{p.wishlistCount}</span>}
            </button>
            <CartBtn p={p} dark />
            {p.userMenuElement}
          </div>
        </div>
      </nav>
      <section className="relative h-[62vh] min-h-[440px] overflow-hidden">
        <HeroImage p={p} themeId="slate" className="h-full">
          <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/60 to-gray-900/20 pointer-events-none" />
        </HeroImage>
        <div className="absolute inset-0 max-w-7xl mx-auto px-6 flex flex-col justify-end pb-12 pointer-events-none">
          <span className="text-[10px] uppercase tracking-[0.32em] font-bold pointer-events-auto" style={{ color: primary }}><InlineEditableText p={p} field="heroEyebrow" value={copy.eyebrow}>{copy.eyebrow}</InlineEditableText></span>
          <h1 className="mt-3 text-5xl md:text-6xl font-extrabold text-white leading-none max-w-xl pointer-events-auto"><InlineEditableText p={p} field="heroTitle" value={copy.title}>{copy.title}</InlineEditableText></h1>
          <p className="mt-4 text-gray-400 max-w-lg text-sm pointer-events-auto"><InlineEditableText p={p} field="heroSubtitle" value={copy.subtitle}>{copy.subtitle}</InlineEditableText></p>
          <div className="mt-7 flex gap-4 pointer-events-auto">
            <button onClick={() => p.setActiveTab("products")} className="px-8 py-3.5 rounded-xl text-sm font-bold text-white" style={{ backgroundColor: primary, color: "#0f172a" }}><InlineEditableText p={p} field="primaryCtaText" value={copy.primaryCta}>{copy.primaryCta}</InlineEditableText></button>
            <button onClick={() => p.setActiveTab("details")} className="px-8 py-3.5 rounded-xl text-sm font-semibold text-gray-400 border border-gray-700 hover:bg-gray-800"><InlineEditableText p={p} field="secondaryCtaText" value={copy.secondaryCta}>{copy.secondaryCta}</InlineEditableText></button>
          </div>
        </div>
      </section>
      <div className="max-w-7xl mx-auto w-full px-5 py-3">
        <div className="flex gap-1 border-b border-gray-800 pb-px">
          {[["products", getTabLabel(p, "products", "shop")],["services", getTabLabel(p, "services")],["details", getTabLabel(p, "details")]].map(([k,l]) => (
            <button key={k} onClick={() => p.setActiveTab(k)} className="px-5 py-2.5 text-sm font-semibold transition" style={p.activeTab===k ? { color:"#fff", borderBottom:`2px solid ${primary}` } : { color:"rgba(255,255,255,0.40)" }}>{l}</button>
          ))}
        </div>
      </div>
      <section className="flex-1 max-w-7xl mx-auto w-full px-5 pb-12"><TabContent p={p} dark /></section>
      <StoreFooter p={p} dark />
    </div>
  );
}

// ─── Grove ───────────────────────────────────────────────────────────────────